module.exports = () => {
	jQuery(document).ready(function () {

        let slider = jQuery('.matrix-slider').slick({
			dots: false,
			infinite: false,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			centerPadding: '40px',
			autoplay: false,
			autoplaySpeed: 2000,
			mobileFirst: true,
			swipeToSlide: false,
            touchMove: false,
            draggable: false,
		}); 

        window.setTimeout(function() {
            let validationTrigger = document.querySelector('#validation-trigger input');
            validationTrigger.click();
            validationTrigger.click();

            // enable/disable buttons on input changes
            let inputs = document.querySelectorAll('.matrix-slider input, .matrix-slider select, .matrix-slider textarea');
            let slides = document.querySelectorAll('.matrix-slider .slide');
            inputs.forEach(input => {
                input.addEventListener('change', function() {

                    // check each slide and enable/disable button
                    slides.forEach(slide => {
                        let button = slide.querySelector('button, input[type="submit"]');
                        if (button) {
                            window.setTimeout(function() {
                                let notValid = slide.querySelector(".wpcf7-not-valid");
                                if (notValid) {
                                    button.disabled = true
                                } else {
                                    button.disabled = false
                                }
                            }, 100);
                        }
                    });

                });
            });
        }, 200);


        // handle next button
        let nextButtons = document.querySelectorAll('.matrix-slider .next');
        nextButtons.forEach(button => {
            button.addEventListener('click', function() {
                slider.slick('slickNext');
            });
        });


        // resize on slider change
        const resizeContainer = function() {
            let container = document.querySelector('.matrix_form form');
            let currentSlide = document.querySelector('.matrix-slider .slide.slick-active');
            let height = currentSlide.clientHeight;
            container.style.height = height + "px";
        }
        resizeContainer();

        slider.on("afterChange", function() {
            resizeContainer();
        });

    })
}